import { createContext, useContext } from 'react';
import { ItemContext } from './types';

export const ItemPageContext = createContext<ItemContext>({} as any);
export const useItemContext = () => useContext(ItemPageContext);
